import { StyleSheet, Platform } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const {
    borderRadiusFull,
    borderSize,
    colorBgBase,
    colorBorderInput,
    colorBgPrimaryLight,
    colorBgSuccess,
    colorBgPromotion,
    colorText,
    space05,
    space6,
    space8,
  } = theme();

  return StyleSheet.create({
    pill: {
      alignItems: "stretch",
      backgroundColor: colorBgBase,
      borderRadius: borderRadiusFull,
      borderWidth: borderSize,
      flexDirection: "column",
      flex: 0,
      height: space8,
      justifyContent: "center",
      paddingHorizontal: space6,
      ...Platform.select({
        web: {
          flexBasis: "auto",
          flexShrink: 0,
        },
      }),
    },
    pillBasic: {
      borderColor: colorBorderInput,
    },
    pillBasicActive: {
      backgroundColor: colorBgPrimaryLight,
      borderColor: colorText,
      borderWidth: space05,
    },
    pillPrimary: {
      borderColor: colorBgSuccess,
    },
    pillPrimaryActive: {
      backgroundColor: colorBgPromotion,
      borderColor: colorBgSuccess,
      borderWidth: space05,
    },
    text: {
      color: colorText,
      paddingTop: 0,
    },
  });
};

export { style };
